'use client';

import { c as _c } from "react/compiler-runtime";
import { CheckCircle, Info, Warning, WarningOctagon } from '@phosphor-icons/react';
import type { Variants } from 'motion/react';
import { AnimatePresence } from 'motion/react';
import * as m from 'motion/react-m';
import { useState } from 'react';
import { cx } from '../../cx';
import { useLayoutEffectSSR } from '../../hooks/use-layout-effect-ssr';
import { useMediaState } from '../../hooks/use-media-state';
import { uiTestId } from '../../test-ids';
export interface ToastMessageProps {
  children: React.ReactNode;
  actionLabel?: string;
  actionOnClick?: () => void;
  onClick?: () => void;
  type?: 'success' | 'error' | 'warning' | 'neutral';
  visible?: boolean;
  variantConfig?: Variants;
}
const VARIANT_CONFIG = {
  initial: {
    y: '150%'
  },
  animate: {
    y: 0
  },
  exit: {
    y: '150%'
  }
};
export function ToastMessage(t0) {
  const $ = _c(14);
  const {
    children,
    actionLabel,
    actionOnClick,
    onClick,
    type,
    visible,
    variantConfig: t1
  } = t0;
  const variantConfig = t1 === undefined ? VARIANT_CONFIG : t1;
  const isMobile = useMediaState("mobile");
  const [loaded, setLoaded] = useState(false);
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setLoaded(true);
    };
    t3 = [];
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  useLayoutEffectSSR(t2, t3);
  let t4;
  if ($[2] !== actionLabel || $[3] !== actionOnClick || $[4] !== children || $[5] !== isMobile || $[6] !== loaded || $[7] !== onClick || $[8] !== type || $[9] !== variantConfig || $[10] !== visible) {
    t4 = visible && loaded && <m.div key="toast" initial="initial" animate="animate" exit="exit" variants={variantConfig} transition={{
      duration: 0.3
    }} custom={isMobile} className={cx("flex w-full max-w-[548px] cursor-pointer items-center justify-between gap-4 rounded-2xl p-6 text-white shadow sm:w-[548px]", {
      "bg-success": type === "success",
      "bg-error": type === "error",
      "bg-warning": type === "warning",
      "bg-aubergine": type === "neutral" || !type
    })} onClick={onClick} data-testid={uiTestId("ToastMessage.root")}><div className="flex items-center gap-4"><div className="size-6 shrink-0">{type === "success" && <CheckCircle height={24} width={24} />}{type === "error" && <WarningOctagon height={24} width={24} />}{type === "warning" && <Warning height={24} width={24} />}{(type === "neutral" || !type) && <Info height={24} width={24} />}</div><div>{children}</div></div>{actionLabel && actionOnClick && <button className="font-button-m" onClick={actionOnClick}>{actionLabel}</button>}</m.div>;
    $[2] = actionLabel;
    $[3] = actionOnClick;
    $[4] = children;
    $[5] = isMobile;
    $[6] = loaded;
    $[7] = onClick;
    $[8] = type;
    $[9] = variantConfig;
    $[10] = visible;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t4) {
    t5 = <AnimatePresence>{t4}</AnimatePresence>;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}